import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const simulatorJudgementSlice = createSlice({
  name: 'simulatorJudgement',
  initialState: { simulatorJudgement: initialState },
  reducers: {
    simulatorJudgementApi: (state, data) => {
      state.simulatorJudgement = data.payload;
    },
  },
});

export const { simulatorJudgementApi } = simulatorJudgementSlice.actions;

export default simulatorJudgementSlice.reducer;
